import { Pipe, PipeTransform } from '@angular/core';

/** Sets possessive pronouns **/
@Pipe({
  name: 'possessiv',
})
export class PossessivPipe implements PipeTransform {
  transform(value: any, language: string): any {
    if (language == 'en') {
      return value === 'Frau' ? 'her' : 'his';
    } else {
      return value === 'Frau' ? 'ihrer' : 'seiner';
    }
  }
}
